import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-approve-success',
  standalone: true,
  imports: [MatDialogModule,CommonModule],
  templateUrl: './approve-success.component.html',
  styleUrl: './approve-success.component.scss'
})
export class ApproveSuccessComponent {
  message: string = ""
  title:string=""
  action:string=""
  actionType: string="add"
  cancelButtonText = "Cancel"
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ApproveSuccessComponent>) {
    if (data) {
      this.message = data.message;
      this.title= data.title;
      this.action = data.actionType
    }
    this.dialogRef.updateSize('300vw','300vw')
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
